import React from "react";
import { Input } from "@teals/ui-web";
import {
  StepContent,
  DetailSectionTitle,
  InfoBanner,
  InfoBannerIcon,
} from "../styles";

interface StepCredentialsProps {
  appId: string;
  onAppIdChange: (val: string) => void;
  apiKey: string;
  onApiKeyChange: (val: string) => void;
  indexName: string;
  onIndexNameChange: (val: string) => void;
}

const monoStyle: React.CSSProperties = {
  fontFamily: "'SF Mono', 'Fira Code', monospace",
};

const StepCredentials: React.FC<StepCredentialsProps> = ({
  appId,
  onAppIdChange,
  apiKey,
  onApiKeyChange,
  indexName,
  onIndexNameChange,
}) => {
  return (
    <StepContent>
      <DetailSectionTitle>Algolia credentials</DetailSectionTitle>
      <p>
        Provide credentials so Lumina can connect and read index settings. Keys
        are stored securely and used only to proxy agent queries.
      </p>

      <Input
        label="Application ID"
        value={appId}
        placeholder="e.g. ABCD1234EF"
        onChange={(e) => onAppIdChange(e.target.value)}
        style={monoStyle}
      />
      <Input
        label="Admin API Key"
        type="password"
        value={apiKey}
        placeholder="Your Algolia admin API key"
        onChange={(e) => onApiKeyChange(e.target.value)}
        style={monoStyle}
      />
      <Input
        label="Index Name"
        value={indexName}
        placeholder="e.g. prod_products"
        onChange={(e) => onIndexNameChange(e.target.value)}
        style={monoStyle}
      />

      <InfoBanner>
        <InfoBannerIcon>{"\u{1F512}"}</InfoBannerIcon>
        <span>
          Use an Admin API key with read access to index settings. Lumina never
          modifies your remote index data during registration.
        </span>
      </InfoBanner>
    </StepContent>
  );
};

export default StepCredentials;
